import { cn } from "@/lib/cn";

interface ExploreChartSkeletonProps {
  className?: string;
}

export function ExploreChartSkeleton({ className }: ExploreChartSkeletonProps) {
  return (
    <div className={cn("animate-pulse", className)}>
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div className="space-y-2">
          <div className="h-4 w-24 rounded bg-[var(--color-muted)]" />
          <div className="h-10 w-36 rounded bg-[var(--color-muted)] sm:w-44" />
        </div>
        <div className="h-6 w-20 rounded bg-[var(--color-muted)]" />
      </div>

      <div className="relative h-[320px] overflow-hidden rounded-xl border border-[var(--color-border)] bg-[#F8FAFC]">
        <div className="absolute inset-x-12 inset-y-4 flex flex-col justify-between">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="h-px w-full bg-[var(--color-border)]/70" />
          ))}
        </div>
        <div className="absolute bottom-9 left-12 right-4 top-8 rounded-t-[40%] bg-[var(--color-muted)]/60" />
        <div className="absolute bottom-4 left-12 right-4 flex justify-between">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="h-2 w-8 rounded bg-[var(--color-muted)]" />
          ))}
        </div>
      </div>
    </div>
  );
}
